import { useT } from "../i18n";

/* ══════════════════════════════════════════════════════════════════
   **Zu lang wird gesagt, nicht abgeschnitten** (N4-16, Nachprüfung Runde 4).

   Die Belegtextfelder trugen `maxlength=2000`: 3.000 eingefügte Zeichen
   wurden still auf 2.000 gekürzt, und gespeichert war ein Text, den niemand
   so geschrieben hatte. Jetzt bleibt alles stehen, der Satz darunter nennt
   Grenze und Länge (derselbe Satz wie `fehler.eingabeZuLang` der API), und
   gespeichert wird erst, wenn es passt.
   ══════════════════════════════════════════════════════════════════ */

/** Dieselbe Grenze wie die API für Vor- und Nachtext (`eingabe.vortext {hoechstens 2000}`). */
export const BELEGTEXT_HOECHSTENS = 2000;

export function textZuLang(text: string, hoechstens = BELEGTEXT_HOECHSTENS): boolean {
  return text.length > hoechstens;
}

export function Laengensatz({ text, hoechstens = BELEGTEXT_HOECHSTENS }: { text: string; hoechstens?: number }) {
  const t = useT();
  if (!textZuLang(text, hoechstens)) return null;
  return (
    <p className="nebensatz laengensatz" role="alert">
      {t("fehler.eingabeZuLang", {
        hoechstens: hoechstens.toLocaleString("de-DE"),
        laenge: text.length.toLocaleString("de-DE"),
      })}
    </p>
  );
}
